@if (src) {
  <img [src]="src" [alt]="name || ''" />
}
@if (!src) {
  <span class="bv-avatar__initials">{{ initials }}</span>
}
